import type { RefObject } from 'react'

import { useEffect, useState } from 'react'

interface InViewOptions {
    threshold?: number
    rootMargin?: string
    once?: boolean
}

export const useInView = <T extends Element>(
    ref: RefObject<T | null>,
    { threshold = 0.2, rootMargin = '0px', once = true }: InViewOptions = {}
): boolean => {
    const [inView, setInView] = useState(false)

    useEffect(() => {
        const node = ref.current

        if (!node) return

        if (typeof IntersectionObserver === 'undefined') {
            setInView(true)
            return
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true)

                if (once) observer.disconnect()
            }
            else if (!once) {
                setInView(false)
            }
        }, { threshold, rootMargin })

        observer.observe(node)

        return () => observer.disconnect()
    }, [ref, threshold, rootMargin, once])

    return inView
}
